module.exports = __webpack_public_path__ + "static/media/meal-plan-in-progress.57f3c851.png";